import { render } from "./UserFullName.vue?vue&type=template&id=37502f41"
import script from "./UserFullName.vue?vue&type=script&lang=js"
export * from "./UserFullName.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__